// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"styles_imageContainer__sgwIJ","image":"styles_image__kqu4Y","shareArea":"styles_shareArea__4SUef","show":"styles_show__7W3Qs"};